.message {
	display: flex;
	align-items: center;
	gap: 5px;
	font-size: 14px;
	font-weight: 400;
	color: #2f2f2f;
}

svg.icon {
	width: 16px;
	height: 16px;
	color: #b40030;
}
